<template>
  <div class="content-view">
    <b-navbar type="dark" variant="dark">
      <b-navbar-nav>
        <b-nav-form>
          <b-button variant="primary" @click="filters.page--">Poprzednia strona</b-button>
          <div class="page-number">{{ filters.page }}</div>
          <b-button variant="primary" @click="filters.page++">Następna strona</b-button>

          <model-list-select :list="filterDicts.cities"
                     v-model="filters.cityId"
                     option-value="id"
                     option-text="name"
                     class="m-md-2"
                     placeholder="Wybierz miejscowość">
          </model-list-select>

          <b-button variant="default" class="resetbtn" @click="clearCitySearch"><b-icon-x-circle /></b-button>

          <b-form-input
            :disabled="filters.cityId == -1"
            class="m-md-2"
            v-model="filters.address"
            placeholder="Wpisz adres" style="max-width: 80%"></b-form-input>

           <b-button variant="default" class="resetbtn" @click="clearAddressSearch"><b-icon-x-circle /></b-button>
        </b-nav-form>
      </b-navbar-nav>
    </b-navbar>

    <building-modal v-if="showBuildingsModal"/>
    <delete-building-modal @building-deleted="getBuildings"/>
    <buildings-table :buildings="buildings" v-if="buildings !== null" />
    <div class="text-center pt-5" v-if="buildings === null">
      <b-spinner label="Wczytuję"></b-spinner>
      <p>Wczytuję listę budynków</p>
    </div>
  </div>
</template>

<script>
import BuildingCard from "@/components/buildings/BuildingCard";
import Breadcrumps from "@/components/common/Breadcrumps";
import BuildingModal from "@/components/buildings/BuildingModal";
import DeleteBuildingModal from "@/components/buildings/DeleteBuildingModal";
import LocationsModel from "@/models/locations";
import BuildingsTable from "../components/buildings/BuildingsTable";
import _ from "lodash";
import axios from "axios";

import { ModelListSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
  name: "Buildings",
  data() {
    return {
      buildings: null,
      filters: {
        page: 0,
        cityId: -1,
        address: ""
      },
      filterDicts: {
        cities: [],
        streets: [],
      }
    }
  },
  methods: {
    getBuildings() {
      this.buildings = null;
      LocationsModel.getUserBuildings(this.filters.page)
        .then((res) => this.buildings = res.data);
    },
    getCities() {
      return axios.get(`/api/locations/cities`)
        .then((res) => {
          this.filterDicts.cities = res.data;
        })
    },
    clearCitySearch() {
      this.filters.address = "";
      this.filters.cityId = -1;
    },
    clearAddressSearch() {
      this.filters.address = "";
    },
    performAddressSearch: _.debounce(function() {
        this.buildings = null;
        LocationsModel.getUserBuildings(this.filters.page, this.filters.cityId, -1, false, this.filters.address)
            .then((res) => this.buildings = res.data);
    }, 250)
  },
  computed: {
    selectedCity() {
      if (this.filters.cityId === -1) {
        return "Wszystkie";
      }
      return this.filterDicts.cities.filter((el) => el.id === this.filters.cityId)[0].name;
    },
    showBuildingsModal() {
      return this.$store.state.showBuildingsModal;
    },
    declarationModalState() {
      return this.$store.state.showDeclarationModal;
    }
  },
  watch: {
    "filters.cityId": function () {
      this.filters.page = 0;
      this.getBuildings();
    },
    "filters.page": function (newValue) {
      newValue = parseInt(newValue);
      if (newValue < 0) {
        this.filters.page = 0;
      }
      this.getBuildings();
    },
    "filters.address": function () {
      this.performAddressSearch();
    },
    showBuildingsModal(newValue) {
      if (!newValue) {
        this.getBuildings();
      }
    },
    declarationModalState(newValue) {
      if (!newValue) {
        this.getBuildings();
      }
    },
  },
  mounted() {
    this.getBuildings();
    this.getCities();
  },
  components: {BuildingsTable, DeleteBuildingModal, Breadcrumps, BuildingCard, BuildingModal, ModelListSelect}
}
</script>

<style scoped>
.buildings-list {
  display: flex;
  flex-wrap: wrap;
}


.page-number {
  width: 2rem;
  color: #FFFFFF;
  text-align: center;
}

.ui.fluid.dropdown {
  width: auto;
  min-width: 12em;
}

.resetbtn {
  color: #FFFFFF;
  padding: 0;
}
</style>
